import { render, staticRenderFns } from "./LayoutLogged.vue?vue&type=template&id=a04b0780&"
import script from "./LayoutLogged.vue?vue&type=script&lang=js&"
export * from "./LayoutLogged.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports